import {EModalMode} from "@components/elements/EModalMode";
import React, {useEffect} from "react";
import {twMerge} from "tailwind-merge";

export function Modal(props: { type: EModalMode, children: React.ReactNode, onClose: () => void, modalContainerClassName?: string, closeCrossSize?: number }) {

    const { onClose } = props;
    const handleEscapeKeyDown = React.useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener('keydown', handleEscapeKeyDown);
        return () => {
            document.removeEventListener('keydown', handleEscapeKeyDown);
        }
    }, [handleEscapeKeyDown]);

    return (<div
        className={twMerge(props.type === EModalMode.FULL_SCREEN && "w-full h-full",
            props.type === EModalMode.FIT_CONTENT && "w-full h-full max-h-[100vh] max-w-[100vw] md:max-w-3xl md:max-h-3xl",
            props.type === EModalMode.MAX_SIZE && "w-screen h-screen",
            "flex flex-col items-center justify-center")}
        onClick={() => props.onClose()}
        tabIndex={-1} // prevents the modal from capturing escape key events when the focus is inside the modal
        onKeyDown={(e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
            }
        }}
    >
        <div
            className={twMerge(
                "relative",
                "md:mt-8 md:mb-8",
                "bg-white dark:bg-gray-800",
                "md:rounded-lg shadow-lg",
                "max-h-100 overflow-y-auto scrollbar-thin",
                "scrollbar-thumb-gray-400 scrollbar-track-gray-200 scrollbar-thumb-rounded scrollbar-track-rounded",
                "hover:scrollbar-thumb-gray-500 dark:scrollbar-thumb-gray-500 dark:scrollbar-track-gray-700",
                props.modalContainerClassName,
                props.type === EModalMode.MAX_SIZE && "w-full h-full max-w-3xl max-h-3xl",
                props.type === EModalMode.FIT_CONTENT && "max-h-[100vh] max-w-[100vw] m-0",
                props.type === EModalMode.FULL_SCREEN && "w-full h-full",)}
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
        >
            {props.children}
        </div>
    </div>);
}